if (!customElements.get('portfolio-grid')) {
    class PortfolioGrid extends HTMLElement {

        static get observedAttributes() {
            return ['current-project'];
        }

        constructor() {
            super();

            this.currentProject = this.getAttribute('current-project');
            this.currentView = 'full';
            this.ticking = false;

            this.elProjects = this.querySelectorAll('.portfolio-grid--project');
            this.elActive = this.querySelector('[data-active-title]');

            this.elButtons = this.querySelectorAll('.portfolio-grid--button');

            this.elButtons.forEach(el => el.addEventListener('click', this.setView.bind(this)));
        }

        connectedCallback() {
            this.initScroll();
            requestAnimationFrame(() => this.updateActiveTitle());
        }

        disconnectedCallback() {
            if (this.boundScrollSpy) {
                window.removeEventListener('scroll', this.boundScrollSpy);
                window.removeEventListener('resize', this.boundScrollSpy);
                this.scrollSpyInitialized = false;
                this.boundScrollSpy = null;
            }
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'current-project') {
                this.currentProject = newValue;
                this.elActive.textContent = this.currentProject;
            }
        }

        setView(ev) {
            ev.preventDefault();
            const elButton = ev.currentTarget;
            this.currentView = elButton.getAttribute('data-button');
            this.elButtons.forEach(el => el.classList.remove('active'));
            elButton.classList.add('active');
            this.classList.add('transitioning');
            setTimeout(() => {
                this.classList.toggle('half-view', this.currentView == 'half');
                this.classList.remove('transitioning');
                if (this.currentView !== 'half') {
                    this.updateActiveTitle();
                }
            }, 1000);

        }

        initScroll() {
            if (this.scrollSpyInitialized) return;
            this.scrollSpyInitialized = true;

            const onScroll = () => {
                if (this.ticking) return;
                this.ticking = true;
                window.requestAnimationFrame(() => {
                    this.updateActiveTitle();
                    this.ticking = false;
                });
            };

            this.boundScrollSpy = onScroll;
            window.addEventListener('scroll', this.boundScrollSpy, { passive: true });
            window.addEventListener('resize', this.boundScrollSpy);
        }

        /**
         * Uses the same vertical line as the sticky title panel: when an image top crosses
         * that line (viewport Y), that project becomes active. Taking the last project in
         * DOM order whose image top is at or above the line avoids ratio-based flicker.
         */
        updateActiveTitle() {
            if (this.classList.contains('half-view') || !this.elActive) return;

            // Same viewport Y as the sticky title: when an image top crosses this line, that project is active.
            const lineY = this.elActive.getBoundingClientRect().top;
            let nextProject = null;

            for (const el of this.elProjects) {
                const img = el.querySelector('.portfolio-grid--project-image');
                if (!img) continue;
                if (img.getBoundingClientRect().top <= lineY) {
                    nextProject = el.dataset.project;
                }
            }

            const fallback = this.elProjects[0]?.dataset?.project;
            const next = nextProject ?? fallback;
            if (next && next !== this.getAttribute('current-project')) {
                this.setAttribute('current-project', next);
            }
        }
    }
    customElements.define('portfolio-grid', PortfolioGrid);
}